import { useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';

const useDraggableRows = (data, dropCb) => {
  const [updatedList, setUpdatedList] = useState(data);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [draggingId, setDraggingId] = useState();
  const [isDroppedOutside, setIsDroppedOutside] = useState(false);

  useDeepCompareEffect(() => {
    setUpdatedList(data);
  }, [data]);

  const handleDragStart = (e, index) => {
    setDraggingId(updatedList?.find(l => l.index === index)?.id);
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.target.style.cursor = 'grabbing';
    const img = new Image();
    e.dataTransfer.setDragImage(img, 0, 0);
    e.dataTransfer.setData('text/plain', ''); // workaround for Firefox
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const hoveredItem = updatedList?.find(i => i.index === index);
    let newList = updatedList;
    if (!hoveredItem.isHidden) {
      newList = data?.map((item) => {
        if (item.index === draggedIndex) {
          return {
            ...item,
            index,
          };
        } else if (draggedIndex < index && item.index > draggedIndex && item.index <= index) {
          return {
            ...item,
            index: item.index - 1,
          };
        } else if (draggedIndex > index && item.index >= index && item.index < draggedIndex) {
          return {
            ...item,
            index: item.index + 1,
          };
        }
        return item;
      });
    }
    setUpdatedList(newList?.sort((a, b) => a.index - b.index));
    setIsDroppedOutside(false);
  };

  const handleDragEnd = () => {
    if (isDroppedOutside) {
      setUpdatedList(data);
    } else {
      dropCb(updatedList, draggingId);
    }
    setDraggedIndex(null);
    setDraggingId();
  };

  const handleDropzoneDragOver = (e) => {
    e.preventDefault();
    setIsDroppedOutside(false);
  };

  const handleDropzoneDragLeave = () => {
    setIsDroppedOutside(true);
  };

  return [
    updatedList,
    index => index || index === 0 ?
      {
        onDragStart: e => handleDragStart(e, index),
        onDragOver: e => handleDragOver(e, index),
        onDragEnd: e => handleDragEnd(e, index),
      } :
      {},
    {
      onDragOver: handleDropzoneDragOver,
      onDragLeave: handleDropzoneDragLeave,
    },
    id => id && id === draggingId ? {
      boxShadow: '0 2px 5px 0 rgba(0, 0, 0, .26)',
      opacity: 1,
      backgroundColor: '#f8f8f8',
      transform: 'translateY(-3px)',
      borderRadius: '3px',
    } : {},
    () => ({ pointerEvents: !draggingId ? 'auto' : 'none' }),
    id => ({
      cursor: id === draggingId ? 'grabbing' : 'grab',
    }),
  ];
};

export default useDraggableRows;
